<template>
  <div class="main-content">

    <sweet-modal
      class="photosPreviewModal"
      ref="photosPreviewModal"
      width="90%"
      @close="closeModal"
      overlay-theme="dark"
    >
      <div>
        <h4>{{ selectedDrug && selectedDrug.title }}</h4>
        <div class="flex photoBlock" v-if="selectedDrugId" style="margin-bottom: 20px;">
          <div class="project_block" v-for="project in $AllProjects" :key="project.id" v-if="project.is_active">
            <div>
              <h4>{{ project.name }}</h4>
              <template
                v-if="photoData[project.id] && photoData[project.id][selectedDrugId] && photoData[project.id][selectedDrugId].full">
                <div class="flex justify-content-between">
                  <button @click="rotateImage(project.id, 'left')" class="btn btn-sm btn-outline-primary">
                    <i class="icon-fa icon-fa-rotate-left"></i>
                  </button>
                  <button @click="rotateImage(project.id, 'right')" class="btn btn-sm btn-outline-primary">
                    <i class="icon-fa icon-fa-rotate-right"></i>
                  </button>
                </div>
                <img :src="photoData[project.id][selectedDrugId].full + '?v=' + todayTimestamp" alt="">
                <div class="flex flex-direction-column">
                  <button @click="updateStatus(project.id, false)" :disabled="actionLoading[project.id].updateStatus"
                          v-if="photoData[project.id][selectedDrugId].temp_photo == 1"
                          style="font-size: 13px;margin-bottom: 5px;padding: 5px 8px !important;"
                          class="btn btn-sm btn-success">
                    <template v-if="actionLoading[project.id].updateStatus">
                      <scale-loader :loading="true" color="white" height="12px"></scale-loader>
                    </template>
                    <template v-else>
                      Сделать постоянным
                    </template>
                  </button>
                  <button @click="updateStatus(project.id, true)" :disabled="actionLoading[project.id].updateStatus"
                          v-if="photoData[project.id][selectedDrugId].temp_photo == 0"
                          style="font-size: 13px;margin-bottom: 5px;padding: 5px 8px !important;"
                          class="btn btn-sm btn-success">
                    <template v-if="actionLoading[project.id].updateStatus">
                      <scale-loader :loading="true" color="white" height="12px"></scale-loader>
                    </template>
                    <template v-else>
                      Сделать временным
                    </template>
                  </button>
                  <button @click="deletePhoto(project.id)" :disabled="actionLoading[project.id].delete"
                          class="btn btn-sm btn-warning" style="font-size: 13px;">
                    <template v-if="actionLoading[project.id].delete">
                      <scale-loader :loading="true" color="white" height="12px"></scale-loader>
                    </template>
                    <template v-else>
                      Удалить
                    </template>
                  </button>
                </div>
              </template>
              <template v-else>
                <div class="no_image photo"></div>
              </template>
              <label v-if="photoOptions.noRusPhoto.includes(project.id)" class="pointer"
                     style="font-size: 13px; margin-top: 8px;">
                <input type="checkbox" @change="noRusPhoto(project.id,
                    !(photoData?.[project.id]?.[selectedDrugId]?.no_rus_photo !== undefined
                    && photoData?.[project.id]?.[selectedDrugId]?.no_rus_photo))"
                       :checked="photoData?.[project.id]?.[selectedDrugId]?.no_rus_photo !== undefined &&
                           photoData?.[project.id]?.[selectedDrugId]?.no_rus_photo"
                       style="position: relative;top: 3px;">&nbsp;
                <template v-if="actionLoading[project.id]?.noRusPhoto">
                  <scale-loader :loading="true" color="white" height="12px"></scale-loader>
                </template>
                <span v-else>Невозможно найти русскоязычное фото</span>
              </label>
            </div>
          </div>
        </div>
        <div>
          <div v-if="uploadedImages" style="margin-top: 28px; margin-bottom: 10px;">
            <h4>Новые фотографии</h4>
            <div class="flex justify-content-center">
              <div class="no_image" v-if="uploadedImages[project.id]" v-for="project in $AllProjects" :key="project.id">
                <template v-if="uploadedImages[project.id]">
                  <h4>{{ project.name }}</h4>
                  <img :src="uploadedImages[project.id].url" alt="">
                  <button @click="removeFromImagePull(project.id)" type="button" class="btn btn-default">не выгружать на
                    сайт
                  </button>
                  <div class="form-group">
                    <input type="checkbox" v-model="uploadedImages[project.id].fileData.tempPhoto"
                           :id="`ch_temp_${project.id}`"
                           :disabled="uploadedImages[project.id].fileData.mirrorId">
                    <label class="pointer" :for="`ch_temp_${project.id}`">Временное фото</label>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div style="display: inline-block; text-align: left;">
            <!--            <label>Проект:</label>-->
            <!--            <select id="selectedSite" class="form-control" @change="changeSelectedSite">-->
            <!--              <option value=""></option>-->
            <!--              <option v-for="project in $AllProjects" :key="project.id" v-if="project.is_active"-->
            <!--                      :value="+project.id">{{-->
            <!--                  project.name-->
            <!--                }}-->
            <!--              </option>-->
            <!--            </select>-->
          </div>
          <label>
            <span type="button" class="btn btn-info">Выбрать фотографии
            <input type="file" id="uploadPhotos" multiple ref="uploadFilesInput" :disabled="isSaving"
                   @change="filesAdded($event.target.name, $event.target.files)"
                   accept="image/*" class="input-file hidden">
              </span>
          </label>
          <button type="button" :disabled="isSaving" @click="upload" class="btn btn-success">
            <template v-if="isSaving">
              <scale-loader :loading="true" color="white" height="12px"></scale-loader>
            </template>
            <template v-else>
              Загрузить новые
            </template>
          </button>
        </div>
        <div v-if="sitesRequirements.length"
             style="background: #fff5e2; padding: 15px; font-size: 12px; line-height: 151%; text-align: left; max-width: 545px; margin: 0 auto; color: #a68a54; border-radius: 3px; display: flex; justify-content: space-between;">
          <div v-for="project in $AllProjects" v-if="sitesRequirements[project.id] !== undefined" :key="project.id">
            <b>{{ project.name }}</b>: {{ sitesRequirements[project.id].image_ext }},
            {{ sitesRequirements[project.id].images_width }}x{{ sitesRequirements[project.id].images_height }}
          </div>
        </div>
      </div>
    </sweet-modal>

    <div class="card">
      <div class="card-header">
        <h4>Контроль фотографий</h4>
      </div>
      <div class="card-body">
        <div v-if="loading" class="text-center">
          <pulse-loader :loading="true" :color="loadingColor" class="text-center"/>
        </div>
        <div v-else class="table-block">
          <div>
            <div class="form-group m-0">
              <input v-model="showFilter.tempPhoto" type="checkbox" @change="updateView" id="ch_1">
              <label class="pointer" for="ch_1">Показать препараты с временными фото</label>
            </div>
            <div class="form-group m-0">
              <input v-model="showFilter.inStore" type="checkbox" @change="updateView" id="ch_2">
              <label class="pointer" for="ch_2">Показать препараты в наличии на МСК</label>
            </div>
            <div class="form-group m-0">
              <input v-model="showFilter.withComments" type="checkbox" @change="updateView" id="ch_3">
              <label class="pointer" for="ch_3">Показать препараты с комментариями</label>
            </div>
          </div>
          <div class="flex">
            <div class="m-r-10">
              <button @click="updateFilter(1)" type="button"
                      v-bind:class="{'btn btn-outline-primary': true, 'active': filter[1]}">
                <i class="icon-fa icon-fa-check-circle color_green align-bottom"></i> - Фото загружено
              </button>
            </div>
            <div class="m-r-10">
              <button @click="updateFilter(2)" type="button"
                      v-bind:class="{'btn btn-outline-primary': true, 'active': filter[2]}">
                <i class="icon-fa icon-fa-check-circle color_gray align-bottom"></i> - Временное фото
              </button>
            </div>
            <div class="m-r-10">
              <button @click="updateFilter(3)" type="button"
                      v-bind:class="{'btn btn-outline-primary': true, 'active': filter[3]}">
                <i class="icon-fa icon-fa-times-circle color_red align-bottom"></i> - Фото отсутствует
              </button>
            </div>
            <div class="m-r-10">
              <button @click="updateFilter(4)" type="button"
                      v-bind:class="{'btn btn-outline-primary': true, 'active': filter[4]}">
                <i class="icon-fa icon-fa-pause-circle color_yellow align-bottom"></i> - Препарат отсутствует или
                выключен
              </button>
            </div>
          </div>
          <div class="m-t-10">
            всего записей: <strong>{{ localDrugs.length }}</strong>
          </div>
          <div v-if="loadingTable">
            <pulse-loader :loading="true" :color="loadingColor" class="text-center"/>
          </div>
          <div v-else>
            <table-component
              :data="localDrugs"
              filter-placeholder="Поиск препарата"
              sort-by="title"
              sort-order="asc"
              table-class="table table-hover table-sm">
              <table-column show="id" :sortable="true" label="ID"></table-column>
              <table-column label="Препарат">
                <template slot-scope="row">
                  {{ row.title }}
                  <div>
                    <template class="comment" v-for="(comment, index) in (row.internal_comments || [])">
                      <div v-if="comment.comment_type === 1">
                        <p class="text-right">{{ comment.text }}
                          <button @click="removeComment(row.id, index)" class="btn btn-outline-danger btn-xs">х</button>
                        </p>
                        <p class="text-right text-muted fs-11">{{ comment.user_name }} : {{ comment.date }}</p>
                      </div>
                    </template>
                    <button v-if="!addComment[row.id]" @click="addComment[row.id] = !addComment[row.id]"
                            class="btn btn-xs btn-outline-info">добавить комментарий
                    </button>
                    <div class="input-group mb-1" v-if="addComment[row.id]">
                      <input v-model="newComment[row.id]" type="text" class="form-control"
                             placeholder="Комментарий к препарату">
                      <div class="input-group-append">
                        <button @click="updateDrug(row)" class="btn btn-success btn-sm">
                          <i style="font-size:14px" class="icon-fa icon-fa-save"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </table-column>
              <table-column :sortable="false" label="Фотографии">
                <template slot-scope="row">
                  <button @click="getPhotos(row)" class="btn btn-sm btn-info">Просмотр</button>
                </template>
              </table-column>
              <template v-for="project in $AllProjects" v-if="project.is_active">
                <table-column :sortable="false" :label="project.name" :key="project.id">
                  <template slot-scope="row">
                    <template
                      v-if="photoData[project.id] && photoData[project.id][row.id] && photoData[project.id][row.id].status === 1">
                      <i v-bind:class="{
                      'icon-fa icon-fa-check-circle': !!photoData[project.id][row.id].full,
                      'color_green': photoData[project.id][row.id].full && photoData[project.id][row.id].temp_photo == 0,
                      'color_gray': photoData[project.id][row.id].full && photoData[project.id][row.id].temp_photo == 1,
                      'icon-fa icon-fa-times-circle color_red': !photoData[project.id][row.id].full
                    }"></i>
                      <a :href="photoData[project.id][row.id].url" target="_blank">
                        <i class="icon-fa icon-fa-external-link"></i>
                      </a>
                      <!--                      {{ photoData[project.id][row.id] }}-->
                    </template>
                    <template v-else>
                      <i class="icon-fa icon-fa-pause-circle color_yellow"/>
                    </template>
                  </template>
                </table-column>
              </template>
            </table-component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import {TableComponent, TableColumn} from 'vue-table-component'
import {SweetModal} from 'sweet-modal-vue'
import moment from 'moment'

export default {
  title: 'Фотографии препаратов',
  components: {
    TableComponent,
    TableColumn,
    SweetModal
  },
  computed: {
    $AllProjects() {
      const stores = this.$store.getters['platform/projects'].filter(
        (s) => s.id && s.id !== 4 && s.id !== 10
      )
      return _.orderBy(stores, 'id')
    },
  },
  data() {
    return {
      filter: {
        1: false,
        2: false,
        3: false,
        4: false
      },
      newComment: {},
      addComment: {},
      todayTimestamp: moment().unix(),
      actionLoading: {},
      isSaving: false,
      uploadedImages: null,
      selectedDrug: null,
      selectedDrugId: null,
      selectedSiteId: 0,
      sitesRequirements: [],
      sitesRequirementsLegend: [],
      loadingColor: this.$constants.LOADING_COLOR,
      loading: false,
      loadingTable: false,
      showFilter: {
        tempPhoto: false,
        inStore: false,
        withComments: false,
      },
      drugs: [],
      localDrugs: [],
      photoData: {},
      photoOptions: {
        noRusPhoto: [7, 12]
      },
      storeDrugs: [],
      columns: [
        {prop: 'id', name: 'ID'}, {prop: 'title', name: 'Препарат'}, {
          name: 'Object', cellTemplate: (e) => {
            return e
          }
        }
      ],
    }
  },
  mounted() {
    this.getPhotoData();
    /*const test = this.$AllProjects.reduce((acc, p) => {
      acc[p.id] = { ...p }
      return acc
    }, {});
    console.log(test);*/
  },
  methods: {
    removeFromImagePull(projectId) {
      this.uploadedImages = Object.keys(this.uploadedImages).reduce((acc, k) => {
        if (+k !== +projectId) {
          acc[k] = this.uploadedImages[k];
        }
        return acc;
      }, {})
    },
    getTimestamp() {
      return moment().unix();
    },
    async changeSelectedSite() {
      console.log(1);
      let selectedSiteSelect = document.getElementById('selectedSite');
      console.log(parseInt(selectedSiteSelect.value));
      if (selectedSiteSelect.length) {
        this.selectedSiteId = parseInt(selectedSiteSelect.value);
      }
    },
    async removeComment(drugId, index) {
      const i = this.localDrugs.findIndex((d) => d.id === drugId)
      // console.log(i, drugId, index)
      const {data} = await api.post('/drugs/updateDrug', {
        action: 'removeComment',
        drugId: drugId,
        commentIndex: index,
      })
      if (data.success) {
        delete this.localDrugs[i].internal_comments[index]
        this.localDrugs[i].internal_comments = this.localDrugs[i].internal_comments.filter((c) => c)
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
    },
    async updateDrug(drugData) {
      if (!this.newComment[drugData.id]) return
      const {data} = await api.post('/drugs/updateDrug', {
        action: 'addComment',
        drugId: drugData.id,
        title: drugData.title,
        internalComment: this.newComment[drugData.id],
        commentType: 1 //image comment
      })
      if (data.success) {
        this.addComment[drugData.id] = false
        const index = this.localDrugs.findIndex((d) => d.id === drugData.id)
        let dData = this.localDrugs[index]
        if (!dData.internal_comments) {
          dData.internal_comments = []
        }
        dData.internal_comments.push({
          text: this.newComment[drugData.id],
          user_name: 'Вы',
          date: 'сейчас',
          comment_type: 1
        })
        this.localDrugs[index] = dData
        this.newComment[drugData.id] = null
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
    },
    async rotateImage(projectId, side, mirrorId = null) {
      const {data} = await api.post('/drugs/photoData', {
        'action': 'rotate',
        'drug_id': this.selectedDrugId,
        'project_id': projectId,
        'mirror_id': mirrorId,
        'side': side
      })

      if (data.success) {
        if (mirrorId) {
          this.photoData[projectId][this.selectedDrugId].mirrorsPhotos[mirrorId].full = data.photo_url;
        } else {
          this.photoData[projectId][this.selectedDrugId].full = data.photo_url;
        }
        toastr['success']('Обновлено')
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
    },
    updateFilter(num) {
      Object.keys(this.filter).forEach((k) => {
        this.filter[k] = k === num + ''
      })
      this.updateView()
    },
    async updateStatus(projectId, tempStatus) {
      this.actionLoading[projectId].updateStatus = true
      let {data} = await api.post('/drugs/photoData', {
        'action': 'updateStatus',
        'drug_id': this.selectedDrugId,
        'project_id': projectId,
        'tempStatus': tempStatus
      })
      if (data.success) {
        this.photoData[projectId][this.selectedDrugId].temp_photo = tempStatus
        // this.updateView();
        toastr['success']('Обновлено')
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.actionLoading[projectId].updateStatus = false
    },
    async noRusPhoto(projectId, noRusPhoto) {
      this.actionLoading[projectId].noRusPhoto = true
      let {data} = await api.post('/drugs/photoData', {
        'action': 'mirrorsData',
        'drug_id': this.selectedDrugId,
        'project_id': projectId,
        'no_rus_photo': noRusPhoto,
      })
      if (data.success) {
        if (!this.photoData[projectId][this.selectedDrugId]) this.photoData[projectId][this.selectedDrugId] = {};
        this.photoData[projectId][this.selectedDrugId].no_rus_photo = noRusPhoto
        toastr['success']('Обновлено')
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.actionLoading[projectId].noRusPhoto = false
    },
    async deletePhoto(projectId, mirrorId = null) {
      if (!confirm()) {
        return false;
      }

      this.actionLoading[projectId].delete = true
      let {data} = await api.post('/drugs/photoData', {
        'action': 'delete',
        'drug_id': this.selectedDrugId,
        'project_id': projectId,
        'mirror_id': mirrorId,
      })
      if (data.success) {
        if (mirrorId) {
          this.photoData[projectId][this.selectedDrugId].mirrorsPhotos[mirrorId].full = null;
        } else {
          this.photoData[projectId][this.selectedDrugId].full = null
        }
        toastr['success'](data.message || 'Обновлено')
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.actionLoading[projectId].delete = false
    },
    async upload() {
      console.log('upload');
      const projectIds = this.uploadedImages && Object.keys(this.uploadedImages) || []
      if (!projectIds.length) {
        toastr['warning']('Выберите фотографии')
        return
      }
      this.isSaving = true
      let isMirror = {};
      let formData = new FormData()
      formData.append('drug_id', this.selectedDrugId)
      formData.append('action', 'update')
      projectIds.forEach((id) => {
        // console.log(this.uploadedImages[id]);
        formData.append(`files[${id}]`, this.uploadedImages[id].file);
        isMirror[id] = this.uploadedImages[id].fileData['mirrorId'] !== undefined && this.uploadedImages[id].fileData['mirrorId']
          ? this.uploadedImages[id].fileData['mirrorId']
          : false;
        Object.keys(this.uploadedImages[id].fileData).forEach((key) => {
          formData.append(`fileData[${id}][${key}]`, this.uploadedImages[id].fileData[key])
        })
      });

      let {data} = await api.post('/drugs/photoData',
        formData, true)

      if (data.links && Object.keys(data.links).length) {
        Object.keys(data.links).forEach((pId) => {
          if (isMirror[pId] !== undefined && isMirror[pId]) {
            this.photoData[pId][this.selectedDrugId].mirrorsPhotos[isMirror[pId]].full = data.links[pId]
          } else {
            this.photoData[pId][this.selectedDrugId].full = data.links[pId]
            this.photoData[pId][this.selectedDrugId].temp_photo = this.uploadedImages[pId].fileData.tempPhoto
          }
        })
      }

      if (data.success) {
        this.$refs.photosPreviewModal.close()
        toastr['success'](data.message || 'Обновлено')
      } else {
        let message = 'Ошибка API\n'
        const projects = this.$AllProjects.reduce((acc, p) => {
          acc[p.id] = {...p}
          return acc
        }, {})
        data.errors.forEach((r) => {
          message += 'Проект: ' + projects[r.project_id].name + ' - ' + (r.response && r.response.message || 'ошибка запроса') + '\n'
        })
        toastr['warning'](message)
      }
      this.todayTimestamp = moment().unix()
      this.isSaving = false
    },
    async filesAdded(name, files) {
      console.log(name, files);
      if (!Object.keys(files).length) return
      let images = []
      this.uploadedImages = this.uploadedImages ? this.uploadedImages : {};
      // let siteId = this.selectedSiteId;
      // let siteId = 0;
      Object.keys(files).forEach((k) => {
        const img = new Image()
        img.src = URL.createObjectURL(files[k])
        let vm = this
        img.onload = function () {
          let extIndex = files[k].name.lastIndexOf('.') + 1
          const extension = files[k].name.substring(extIndex)
          console.log(extension, this.height, this.width);
          vm.sitesRequirements.forEach((r, siteId) => {
            console.log(r);
            if (r.image_ext === extension && r.images_height === this.height && r.images_width === this.width) {
              console.log(siteId);
              vm.uploadedImages[siteId] = {
                file: files[k],
                fileData: {tempPhoto: false, width: this.width, height: this.height, ext: extension},
                url: URL.createObjectURL(files[k])
              }
              vm.uploadedImages = {...vm.uploadedImages};
              // console.log(vm.uploadedImages);
              // if (Object.keys(vm.uploadedImages).length === files.length) {
              //   vm.$refs.uploadFilesInput.value = null;
              // }
            }
          })
        }
      })
    },
    closeModal() {
      // this.$refs.photosPreviewModal.close();
      this.$refs.uploadFilesInput.value = null;
    },
    getPhotos(drug) {
      this.selectedDrug = drug
      this.selectedDrugId = drug.id
      this.uploadedImages = null
      this.actionLoading = {}
      this.$AllProjects.forEach((p) => {
        this.actionLoading[p.id] = {
          delete: false,
          updateStatus: false,
        }
      })
      this.actionLoading = {...this.actionLoading}
      this.$refs.photosPreviewModal.open()
    },
    updateView() {
      this.loadingTable = true
      let localDrugs = [...this.drugs]

      Object.keys(this.showFilter).forEach((title) => {
        if (!this.showFilter[title]) return
        switch (title) {
          case 'tempPhoto':
            localDrugs = localDrugs.filter((d) => {
              let found = false
              Object.keys(this.photoData).forEach((siteId) => {
                if (found) return
                if (this.photoData[siteId][d.id] && this.photoData[siteId][d.id].temp_photo == 1) {
                  found = true
                }
              })
              return found
            })
            break
          case 'inStore':
            localDrugs = localDrugs.filter((d) => this.storeDrugs.includes(d.id))
            break
          case 'withComments':
            localDrugs = localDrugs.filter((d) => d.drug && d.drug.internal_comments && d.drug.internal_comments.length)
            break
        }
      })

      let ids = {}
      let useFilter = false
      const t0 = performance.now()
      Object.keys(this.filter).forEach((num) => {
        if (!this.filter[num]) return
        useFilter = true
        if (num === '4') {
          for (let i = 0; i < this.drugs.length; ++i) {
            const d = this.drugs[i]
            Object.keys(this.photoData).forEach((projectId) => {
              if (projectId === '0' || projectId === '10' || ids[d.id]) return
              if (!this.photoData[projectId][d.id] || this.photoData[projectId][d.id].status === 0) {
                ids[d.id] = true
              }
            })
          }
        } else {
          Object.keys(this.photoData).forEach((projectId) => {
            // Object.keys(this.photoData[projectId]).forEach((drugId) => {
            for (const drugId in this.photoData[projectId]) {
              switch (num) {
                case '1':
                  if (this.photoData[projectId][drugId] && this.photoData[projectId][drugId].full && this.photoData[projectId][drugId].temp_photo == 0) {
                    if (!ids[drugId]) {
                      ids[drugId] = true
                    }
                  }
                  break
                case '2':
                  if (this.photoData[projectId][drugId] && this.photoData[projectId][drugId].full && this.photoData[projectId][drugId].temp_photo == 1) {
                    if (!ids[drugId]) {
                      ids[drugId] = true
                    }
                  }
                  break
                case '3':
                  if (this.photoData[projectId][drugId] && this.photoData[projectId][drugId].status && !this.photoData[projectId][drugId].full) {
                    if (!ids[drugId]) {
                      ids[drugId] = true
                    }
                  }
                  break
              }
            }
          })
        }
      })

      if (useFilter) {
        localDrugs = localDrugs.filter((d) => ids[d.id])
      }
      this.localDrugs = [...localDrugs]
      setTimeout(() => {
        this.loadingTable = false
      }, 400)
      const t1 = performance.now()
      console.log('Call to doSomething took ' + (t1 - t0) + ' milliseconds.')
    },
    async getPhotoData() {
      this.loadingTable = true
      let {data} = await api.index('/drugs/photoData')
      this.loading = true
      if (data.success) {
        this.storeDrugs = data.storeDrugs
        this.drugs = data.drugs
        let addComment = {}
        data.drugs.forEach((d) => {
          addComment[d.id] = false
        })
        this.addComment = {...addComment}
        this.localDrugs = data.drugs
        this.photoData = data.photoData

        data.sitesRequirements.forEach((r) => {
          this.sitesRequirements[r.id] = {
            image_ext: r.image_ext,
            images_width: r.images_width,
            images_height: r.images_height,
          };
        });
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.loading = false
      setTimeout(() => {
        this.loadingTable = false
      }, 200)
    }
  }
}
</script>

<style scoped>
.project_block {
  display: flex;
  margin: 3px;
  border: 1px solid lightgray;
  padding: 5px;
}

.project_block_mirror {
  padding-left: 5px;
  margin-left: 12px;
  border-left: 1px solid lightgray;
  height: 100%;
  min-width: 162px;
}

a i.icon-fa {
  font-size: 20px;
}

.icon-fa {
  font-size: 25px;
}

.color_gray {
  color: #bdbdbd;
}

.color_yellow {
  color: #d7dc00;
}

.color_green {
  color: green;
}

.color_red {
  color: #ff9797;
}

.photosPreviewModal img {
  width: 150px;
}

.no_image {
  width: 180px;
}

.no_image.photo {
  background: url('/assets/img/no-img.png');
  width: 180px;
  height: 170px;
  background-size: cover;
}

.photoBlock {
  width: 100%;
  overflow: auto;
}

.flex-direction-column {
  flex-direction: column;
}

.comment p {
  margin-bottom: 2px;
}
</style>

<style>
.photosPreviewModal .sweet-modal {
  /*width: 80%;*/
  /*max-width: 80%;*/
}

.table-block .table-component__table-wrapper {
  height: 60vh;
  overflow: auto;
}
</style>
